// extracted by mini-css-extract-plugin
module.exports = {"title":"GameSubmission_title__2NBc2","textHeading":"GameSubmission_textHeading__3NsXJ","wrapper":"GameSubmission_wrapper__1uC4u","text":"GameSubmission_text__UO8fG"};